import React, { useMemo } from 'react';

const PlaceholderLogo = ({ name }) => (
  <div style={{
    width: '100%',
    height: '30px',
    backgroundColor: '#f0f0f0',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: '#000'
  }}>
    {name}
  </div>
);

const ReasonToUseVisualization = ({ data, logoMap }) => {
  // Extract funnel stages (from first brand) and sort them based on GrabFood's percentages in descending order
  const stages = useMemo(() => {
    if (!data || !data.length) return [];
    const grabFood = data.find(b => b.name === "GrabFood");
    if (!grabFood) return data[0].funnelData.map(item => item.label);

    const sortedStages = grabFood.funnelData.sort((a, b) => b.percentage - a.percentage);
    return sortedStages.map(item => item.label);
  }, [data]);

  // Sort brands in descending order based on base size, keep Grab first
  const sortedBrands = useMemo(() => {
    if (!data || !data.length) return [];

    const validBrands = data.filter(b => (b.funnelData[0]?.Base || 0) > 0);
    const grabFood = validBrands.find(b => b.name === "GrabFood");

    if (!grabFood) return validBrands.sort((a, b) => b.funnelData[0].Base - a.funnelData[0].Base);

    const otherBrands = validBrands.filter(b => b.name !== "GrabFood");
    otherBrands.sort((a, b) => b.funnelData[0].Base - a.funnelData[0].Base);

    return [grabFood, ...otherBrands];
  }, [data]);

  return (
  <div style={{
    padding: '24px',
    fontFamily: "'Inter', sans-serif",
    maxWidth: '1400px',
    margin: '0 auto',
    
    backgroundColor: '#f8fafc'
  }}>
    {/* Table container */}
    <div style={{
      display: 'table',
      borderCollapse: 'collapse',
      width: '100%'
    }}>
      {/* Table header row */}
      <div style={{ display: 'table-row' }}>
        {/* Empty cell for stage labels column */}
        <div style={{ 
          display: 'table-cell', 
          width: '250px',
          verticalAlign: 'top'
        }}></div>
        
        {/* Brand headers */}
        {sortedBrands.map((brand, idx) => (
          <div key={idx} style={{ 
            display: 'table-cell', 
            textAlign: 'center',
                          
            verticalAlign: 'top',
            paddingBottom: '16px',
            // ADD THIS: Give the header a fixed width to match the bars
      width: '150px', 
      // Add padding to match the bar cell's padding
      padding: '0 4px 16px', // Matches the '4px 0' padding on the bar cell

          }}>
            <div style={{ 
              height: '60px',
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
            }}>
              {logoMap[brand.logo] || <PlaceholderLogo name={brand.name} />}
            </div>
            <h3 style={{ 
              color: brand.color, 
              margin: '8px 0 4px 0',
              textAlign: 'center' 
            }}>
              {brand.name}
            </h3>
            <div style={{ fontSize: '14px', color: '#000' }}>
              n={brand.funnelData[0]?.Base || 0}
            </div>
          </div>
        ))}
      </div>

      {/* Table rows for each stage */}
      {stages.map((stage, stageIndex) => (
        <div key={stageIndex} style={{ display: 'table-row' }}>
          {/* Stage label cell */}
          <div style={{
            display: 'table-cell',
            textAlign: 'right',
            fontSize: '12px',
            fontWeight: '500',
            color: '#000',
            padding: '4px 16px 4px 0',
            verticalAlign: 'middle',
            minWidth:'100px',
            height: '40px'
          }}>
            {stage}
          </div>

          {/* Bar cells for each brand */}
          {sortedBrands.map((brand, brandIndex) => {
            const d = brand.funnelData.find(f => f.label === stage);
            const percentage = d ? d.percentage : 0;
            const barColor = brand.color || '#3b82f6';

            return (
              <div key={brandIndex} style={{
                display: 'table-cell',
                verticalAlign: 'middle',
                padding: '4px 0'
              }}>
                <div style={{
                  height: '24px',
                  width: '150px',
                  backgroundColor: '#e2e8f0',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                  <div style={{
                    width: `${percentage}%`,
                    backgroundColor: barColor,
                    height: '100%',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '10px',
                    fontWeight: '100',
                    color: 'black',
                  }}>
                    {percentage>1 ?  percentage.toFixed(0):''}{percentage>1 ?'%':''}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>

    {/* Note for hidden brands */}
    {data.some(b => (b.funnelData[0]?.Base || 0) === 0) && (
      <div style={{
        marginTop: '16px',
        textAlign: 'center',
        fontSize: '13px',
        color: '#000'
      }}>
        *Brands with base size 0 are not shown
      </div>
    )}
  </div>
);
}
export default ReasonToUseVisualization;